<template>
    <div class="goolist">
        <div class="dialog">
            <el-dialog title="关联商品" :visible.sync="dialogVisible" width="1200px" :before-close="handleClose">
                <div class="content" v-loading="tabLoad">
                    <div class="form">
                        <el-form ref="form" :model="filter" inline>
                            <el-form-item>
                                <el-cascader
                                    v-model="select_id"
                                    :props="{ value: 'id', label: 'name', multiple: true, expandTrigger: 'hover' }"
                                    :options="customers"
                                    collapse-tags
                                    @change="selChange"
                                    clearable
                                    style="width: 290px"
                                ></el-cascader>
                            </el-form-item>
                            <el-form-item>
                                <el-input v-model="filter.productName" style="width: 290px" placeholder="请输入商品名称" clearable></el-input>
                            </el-form-item>
                            <el-form-item class="fr">
                                <el-button type="primary" @click="search">查 询</el-button>
                                <el-button type="primary" @click="reset">重 置</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="table">
                        <el-table :data="tableData" style="width: 100%" v-el-table-infinite-scroll="loadMoreData" ref="multipleTable" border>
                            <el-table-column align="center" prop="id" label="商品ID"> </el-table-column>
                            <!-- <el-table-column align="center" prop="imgs_mains" label="商品图片" width="140px">
                                <template slot-scope="scope">
                                    <div class="goods-img">
                                        <el-image :src="scope.row.imgs_mains" style="height: 54px; width: 54px" lazy>
                                            <div slot="error" class="image-slot">
                                                <i class="el-icon-picture-outline"></i>
                                            </div>
                                        </el-image>
                                    </div>
                                </template>
                            </el-table-column> -->
                            <el-table-column align="center" prop="tits" label="商品名称" width="140px">
                                <template slot-scope="scope">
                                    <el-tooltip v-if="scope.row.tits && scope.row.tits.length > 8" :content="scope.row.tits" placement="top" effect="light">
                                        <span>{{ scope.row.tits | countFmt }}</span>
                                    </el-tooltip>
                                    <span v-else>{{ scope.row.tits | countFmt }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="sorts_name" label="分类" width="140px">
                                <template slot-scope="scope">
                                    <el-tooltip :content="scope.row.sorts_name | strFmt" placement="top">
                                        <span>
                                            {{ scope.row.sorts_name | strFmt | countFmt }}
                                        </span>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="select_product.activity_sales_nums" label="销量">
                                <template slot-scope="scope">
                                    {{ !!scope.row.select_product.activity_sales_nums ? scope.row.select_product.activity_sales_nums : 0 }}
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="merchandise_inventory" label="库存"> </el-table-column>
                            <el-table-column align="center" prop="prices_mains" label="销售价（元）"> </el-table-column>
                            <el-table-column align="center" prop="prices_mains" label="不可选原因">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.activity_name != ''">已参加活动</div>
                                    <div v-else-if="scope.row.merchandise_inventory == 0">库存不足</div>
                                    <div v-else>可选</div>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="opt" label="操作" width="160px">
                                <template slot-scope="scope">
                                    <div class="link">
                                        <div v-if="(scope.row.activity_name != '' && !scope.row.checked) || (scope.row.merchandise_inventory == 0 && !scope.row.checked)">不可选</div>
                                        <div v-else>
                                            <div v-if="scope.row.goods_specifications_type_id == 1">
                                                <div v-if="scope.row.checked && scope.row.goods_specifications_type_id == 1">
                                                    <span style="margin-right: 8px">已选</span>
                                                    <el-link type="primary" @click="showDetail(scope.row)">编辑</el-link>
                                                    <el-link type="primary" @click="Cancel(scope.row)">取消</el-link>
                                                </div>
                                                <div v-else>
                                                    <el-link type="primary" @click="showDetail(scope.row)">选择</el-link>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <div v-if="scope.row.selectCount && scope.row.selectCount > 0">
                                                    <span style="margin-right: 8px">已选{{ scope.row.selectCount }}个</span>
                                                    <el-link type="primary" @click="CancelSpec(scope.row)">取消</el-link>
                                                </div>
                                                <el-link type="primary" @click="showDetail(scope.row)">选择</el-link>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <p v-show="nomore" style="text-align: center; margin-top: 20px; color: #999">暂无更多</p>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose" type="info" plain>取 消</el-button>
                    <el-button @click="submit" type="primary" plain>确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
    data() {
        return {
            nomore: false,
            tabLoad: false,
            page: 1,
            size: 10,
            dialogVisible: false,
            filter: {
                classifysIds: [],
                productName: "",
            },
            tableData: [],
            Loading: true,
            date: null,
            customers: [],
            select_id: "",
        };
    },
    filters: {
        strFmt(val) {
            if (val) {
                return val.replace(/,/g, ">");
            }
            return "-";
        },
        countFmt(val) {
            if (val) {
                if (val.length >= 8) {
                    return val.substring(0, 8) + "...";
                }
                return val;
            }
            return "-";
        },
    },
    props: {
        params_type: {
            type: String,
            default: "",
        },
        activityProductData: {
            type: Array,
            default: () => {
                return [];
            },
        },
        activityId: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    mounted() {},
    created() {
        this.Loading = true;
        this.getList(1);
        this.leixChange();
    },
    methods: {
        ...mapActions({
            getProductList: "activity/getProductList",
            getGoodLei: "commodity/getGoodLei",
        }),
        selChange(val) {
            this.filter.classifysIds = val.map((v) => {
                return v[v.length - 1];
            });
        },
        leixChange() {
            this.getGoodLei({
                token: this.$store.state.token,
                classifys_type_id: "2000",
            }).then((res) => {
                if (res.code == 1) {
                    this.customers = res.data.treeData;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 关闭
        submit() {
            this.dialogVisible = false;
        },
        // 多规格取消
        CancelSpec(row) {
            this.$emit("CancelSpec", row);
            let index = this.tableData.indexOf(row);
            row.selectCount = 0;
            this.$set(this.tableData, index, row);
        },
        // 单规格取消
        Cancel(row) {
            this.$emit("Cancel", row);
            // this.reset()
            let index = this.tableData.indexOf(row);
            row.checked = false;
            this.$set(this.tableData, index, row);
        },
        showDetail(row) {
            this.$emit("showDetail", row, this.date);
        },
        // 重置
        reset() {
            this.tableData = [];
            this.filter = {
                classifysIds: [],
                productName: "",
            };
            this.Loading = true;
            this.page = 1;
            this.getList();
            this.select_id = "";
        },
        // 搜索
        search() {
            this.tableData = [];
            this.Loading = true;
            this.page = 1;
            this.getList();
        },
        // 滚动表格获取数据
        async loadMoreData() {
            this.Loading = false;
            if (this.size * this.page >= this.total) {
                this.nomore = true;
            } else if (this.size * this.page < this.total) {
                this.page += 1;
                await this.getList();
                this.nomore = false;
            }
        },
        // 去重
        unique(arr) {
            return Array.from(new Set(arr));
        },
        // 获取列表数据
        getList(tag) {
            if (this.Loading) {
                this.tabLoad = true;
            }
            let opt = {
                token: this.getToken,
                page: tag == 1 ? 1 : this.page, //当前页数
                size: this.size, //每页显示多少条
                name: this.params_type,
                startTime: this.date ? this.date[0] : null,
                endTime: this.date ? this.date[1] : null,
            };
            if (this.activityId != 0) {
                opt.activityId = this.activityId;
            }
            if (this.filter.classifysIds.length > 0) {
                opt.classifysIds = this.filter.classifysIds.toString(); //商品id搜索
            }
            if (this.filter.productName) {
                opt.productName = this.filter.productName; //商品名称搜索
            }
            this.getProductList(opt).then(({ data }) => {
                this.tabLoad = false;
                this.Loading = false;
                if (data.code == 1) {
                    if (data.data.list && data.data.list.length > 0) {
                        this.activityProductData.forEach((item) => {
                            data.data.list.forEach((val) => {
                                if (val.id == item.spuId) {
                                    switch (this.params_type) {
                                        // 拼团
                                        case "activity_team_product":
                                            val.total_stock = item.total_stock;
                                            val.price = item.price;
                                            val.leader_price = item.leader_price;
                                            break;
                                        // 返现
                                        case "activity_share_product":
                                            val.total_stock = item.total_stock;
                                            val.reward_cash = item.reward_cash;
                                            val.reward_share = item.reward_share;
                                            break;
                                        // 接龙
                                        case "activity_link_product":
                                            val.total_stock = item.total_stock;
                                            val.reward_cash = item.reward_cash;
                                            val.reward_share = item.reward_share;
                                            val.activityPrice = item.activityPrice;
                                            break;
                                        default:
                                            break;
                                    }
                                    val.checked = true;
                                }
                            });
                        });

                        data.data.list.forEach((val) => {
                            val.selectCount = 0;
                            this.activityProductData.forEach((item) => {
                                if (item.skuId != 0) {
                                    if (item.goods_id == val.id) {
                                        val.selectCount += 1;
                                    }
                                }
                            });
                        });

                        data.data.list.forEach((item) => {
                            this.tableData.push(item);
                        });
                    }
                    this.total = data.data.count ? data.data.count : 0;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        // 关闭弹窗
        handleClose() {
            this.dialogVisible = false;
            this.date = null;
            this.$emit("close");
        },
    },
};
</script>

<style lang="scss" scoped>
.goolist {
    .content {
        ::v-deep .el-table__body-wrapper {
            height: 400px !important;
            &::-webkit-scrollbar-track-piece {
                background: #d3dce6;
            }
            &::-webkit-scrollbar {
                width: 8px;
            }
            &::-webkit-scrollbar-thumb {
                background: #99a9bf;
                border-radius: 20px;
            }
        }
    }
    ::v-deep .el-table__body-wrapper {
        border-bottom: none;
    }
    ::v-deep .el-table::before {
        display: none;
    }
}
.fr {
    float: right;
}
.el-pagination {
    text-align: right;
    margin-top: 20px;
}
.link a {
    margin: 0 8px;
}
.goods-img {
    .el-image {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        font-size: 36px;
        color: #999;
    }
}
</style>